import { QueryString } from "../models/queryString";

export const parseQueryString = (): QueryString => {
  const uri: string[] = window.location.href.split("?");
  if (uri.length === 2) {
    const qsOptions: string[] = uri[1].split("&");
    const queryStringValues: QueryString = {};

    qsOptions.forEach(qsOpt => {
      const qsKVP = qsOpt.split("=");
      if (qsKVP.length == 2) {
        queryStringValues[qsKVP[0]] = qsKVP[1];
      }
    });
    return queryStringValues;
  }
  return {};
};
